<template>
  <div class="custom-container" v-loading.fullscreen.lock="shoppingCart.isLoading">
    <el-row class="mt-4">
      <el-col :span="8">
        <el-form label-position="left" ref="shoppingCart.data" :rules="rules" status-icon :model="shoppingCart.data" label-width="180px">
          <el-form-item size="small" prop="min_pembelian" label="Minimal Pembelian">
            <el-input
              :disabled="!isEnable"
              type="text"
              v-model="shoppingCart.data.min_pembelian"
              placeholder="Minimum Pembelian"
            ></el-input>
          </el-form-item>
          <el-form-item size="small" prop="min_qty" label="Minimal Qty">
            <el-input
              :disabled="!isEnable"
              type="text"
              v-model="shoppingCart.data.min_qty"
              placeholder="Minimum Qty"
            >
              <template slot="append">Box</template>
            </el-input>
          </el-form-item>
          <el-form-item size="small" prop="tanpa_validasi">
            <el-checkbox @change="e => handleReset(e)" v-model="shoppingCart.data.tanpa_validasi">Tanpa Validasi</el-checkbox>
          </el-form-item>

          <el-form-item>
            <el-button size="small" type="primary" @click="onSubmit">Save</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>


<script>
  import { mapActions, mapState } from "vuex";
  export default {
    data() {
      var validateNumber1 = (rule, value, callback) => {
        let number = value ? value.split('.').join('') : value;
              const re = /^[0-9\b]+$/;
        if (re.test(number)) {
          if (number >= 0) {
            const replace = `${number}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
            this.shoppingCart.data.min_pembelian = replace;
          } else {
            this.shoppingCart.data.min_pembelian = ''
          }
          callback();
        } else {
          const replace = value
            ? value.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, '.')
            : value;
            this.shoppingCart.data.min_pembelian = replace;
          callback();
        }
      };
      var validateNumber2 = (rule, value, callback) => {
        let number = value ? value.toString().split('.').join('') : value;
              const re = /^[0-9\b]+$/;
        if (re.test(number)) {
          if (number >= 0) {
            this.shoppingCart.data.min_qty = number;
          } else {
            this.shoppingCart.data.min_qty = ''
          }
          callback();
        } else {
          const replace = value
            ? value.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, '.')
            : value;
            this.shoppingCart.data.min_qty = replace;
          callback();
        }
      };
      return {
        isEnable: true,
        rules: {
          min_pembelian: [
            { validator: validateNumber1, trigger: 'change' }
          ],
          min_qty: [
            { validator: validateNumber2, trigger: 'change' }
          ],
        }
      }
    },
    computed: {
      ...mapState({
        shoppingCart: state => state.shoppingCart.orderSetting
      })
    },
    methods: {
      ...mapActions({
        getOrderSetting: 'shoppingCart/GetOrderSetting',
        upsertOrderSetting: 'shoppingCart/UpsertOrderSetting'
      }),
      handleReset(e) {
        if (e) {
          this.isEnable = false
        } else {
          this.isEnable = true
        }
        this.shoppingCart.data ={
          min_pembelian: '',
          min_qty: null,
          tanpa_validasi: e
        }
      },
      onSubmit() {
        this.upsertOrderSetting(this.shoppingCart.data)
      }
    },
    created() {
      this.getOrderSetting();
    }
  }
</script>